import React from 'react';
import classes from './ChefCardLoader.module.css';

const ChefCardLoader = () => {
  return <div className={classes.loaderContainer}></div>;
};

export default ChefCardLoader;
